// Middleware
import AuthMiddleware from '@middleware/AuthMiddleware';
import GuestMiddleware from '@middleware/GuestMiddleware';
import InviteMiddleware from '@middleware/InviteMiddleware';
import RedirectIfAuthenticated from '@middleware/RedirectIfAuthenticated';

// Layouts
import LayoutDefault from '@layouts/LayoutDefault';

// Pages
import PageAuthAcceptInvite from '@pages/auth/PageAuthAcceptInvite';
import PageAuthAccount from '@pages/auth/PageAuthAccount';
import PageAuthAuthy from '@pages/auth/PageAuthAuthy';
import PageAuthCompany from '@pages/auth/PageAuthCompany';
import PageAuthLogin from '@pages/auth/PageAuthLogin';
import PageAuthLtd from '@pages/auth/PageAuthLtd';
import PageAuthPasswordChange from '@pages/auth/PageAuthPasswordChange';
import PageAuthPasswordReset from '@pages/auth/PageAuthPasswordReset';
import PageAuthProject from '@pages/auth/PageAuthProject';
import PageAuthSignup from '@pages/auth/PageAuthSignup';
import PageAuthVerifyEmail from '@pages/auth/PageAuthVerifyEmail';

export default {
    path: '/',
    component: LayoutDefault,
    children: [
        {
            path: 'login',
            name: 'login',
            component: PageAuthLogin,
            meta: {
                middleware: GuestMiddleware,
                title: 'Log In',
            }
        },
        {
            path: 'signup',
            name: 'signup',
            component: PageAuthSignup,
            meta: {
                middleware: GuestMiddleware,
                title: 'Sign Up',
            }
        },
        {
            path: 'password-reset',
            name: 'password-reset',
            component: PageAuthPasswordReset,
            meta: {
                middleware: GuestMiddleware,
                title: 'Reset Password',
            }
        },
        {
            path: 'password-change/:temp_token',
            name: 'password-change',
            component: PageAuthPasswordChange,
            meta: {
                middleware: GuestMiddleware,
                title: 'Change Password',
            }
        },
        {
            path: 'verify-email/:temp_token',
            name: 'verify-email',
            component: PageAuthVerifyEmail,
            meta: {
                title: 'Verify Email Address',
            }
        },
        {
            path: 'authy',
            name: 'authy',
            component: PageAuthAuthy,
            meta: {
                middleware: AuthMiddleware,
                title: 'Enter Authy Token',
            }
        },
        {
            path: 'account-setup',
            name: 'account-setup',
            component: PageAuthAccount,
            meta: {
                middleware: AuthMiddleware,
                title: 'Set Up Account',
            }
        },
        {
            path: 'company-setup',
            name: 'company-setup',
            component: PageAuthCompany,
            meta: {
                middleware: AuthMiddleware,
                title: 'Set Up Company',
            }
        },
        {
            path: 'project-setup',
            name: 'project-setup',
            component: PageAuthProject,
            meta: {
                middleware: AuthMiddleware,
                title: 'Set Up First Project',
            }
        },
        {
            path: 'accept-invite/:token',
            name: 'accept-invite',
            component: PageAuthAcceptInvite,
            meta: {
                middleware: InviteMiddleware,
                title: 'Accept Invite',
            }
        },
        {
            path: 'appsumo/:code?',
            name: 'appsumo',
            component: PageAuthLtd,
            meta: {
                middleware: RedirectIfAuthenticated,
                title: 'CrowdPower Lifetime Deal',
            }
        },
        {
            path: 'appsumo/unlock/:code?',
            name: 'appsumo-unlock',
            component: PageAuthLtd,
            meta: {
                middleware: AuthMiddleware,
                title: 'CrowdPower Lifetime Deal',
            }
        },
        {
            path: 'ltd/:code?',
            name: 'ltd',
            component: PageAuthLtd,
            meta: {
                middleware: RedirectIfAuthenticated,
                title: 'CrowdPower Lifetime Deal',
            }
        },
        {
            path: 'ltd/unlock/:code?',
            name: 'ltd-unlock',
            component: PageAuthLtd,
            meta: {
                middleware: AuthMiddleware,
                title: 'CrowdPower Lifetime Deal',
            }
        },
        {
            path: 'slack/callback',
            redirect: { path: 'settings/integrations/slack' },
        },
        {
            path: 'stripe/callback',
            redirect: { path: 'settings/integrations/stripe' },
        },
    ]
}